import type { ReactNode } from 'react';

type SettingsRowProps = {
  title: string;
  description: string;
  children: ReactNode;
  last?: boolean;
};

export function SettingsRow({ title, description, children, last = false }: SettingsRowProps) {
  return (
    <div
      className={`flex flex-wrap items-center gap-x-6 gap-y-3 px-[22px] py-[18px] ${
        last ? '' : 'border-b'
      }`}
      style={{ borderColor: 'var(--gs-line)' }}
    >
      <span className="flex w-full min-w-0 flex-1 flex-col gap-[3px] sm:min-w-[220px]">
        <span className="text-[15px] font-bold" style={{ color: 'var(--gs-ink)' }}>
          {title}
        </span>
        <span className="text-[13px]" style={{ color: 'var(--gs-muted)' }}>
          {description}
        </span>
      </span>
      {children}
    </div>
  );
}
